<template>
    <div class="ml-3 text-center">
        <table class="table table-bordeless table-hover table-sm">
            <thead>
                <tr>
                    <th class="text-center">Objeto Asegurado</th>
                    <th class="text-center">Valor Asegurado</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in listGeneral.listAccesorios" :key="index">
                    <td v-text="item.nombre_accesorio"></td>
                    <td class="text-right" v-text="'$ '+format(item.valorAsegurado)"></td>
                </tr>
                <tr>
                    <td class="font-weight-bold">Total de Inclusión</td>
                    <td class="font-weight-bold text-right" v-html="'$ '+totalInclusion"></td>
                </tr>
                <tr>
                    <td class="font-weight-bold p-2">Prima Neta</td>
                    <td class="text-right" v-html="'$ '+totalPrimaBruta"></td>
                </tr>
                <tr>
                    <td colspan="2" class="font-weight-bold text-center">Impuestos</td>
                </tr>
                <tr>
                    <td>Impuesto SCVS</td>
                    <td class="text-right"
                        v-html="'$ '+format(_.get(objImpuestos,[parametros.id_impuesto_scvs_wizard,'monto'],0.00))">
                    </td>
                </tr>
                <tr>
                    <td>Impuesto SSC</td>
                    <td class="text-right"
                        v-html="'$ '+format(_.get(objImpuestos,[parametros.id_impuesto_ssc_wizard,'monto'],0.00))">
                    </td>
                </tr>
                <tr>
                    <td>Impuesto IVA</td>
                    <td class="text-right"
                        v-html="'$ '+format(_.get(objImpuestos,[parametros.id_impuesto_iva_wizard,'monto'],0.00))">
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="font-weight-bold text-center">Otros</td>
                </tr>
                <tr>
                    <td>Derecho Emisión</td>
                    <td class="text-right"
                        v-html="'$ '+format(_.get(objOtros,[keysOtros[0],'valor_total'],0.00))"></td>
                </tr>
                <tr>
                    <td>Financiamiento</td>
                    <td class="text-right"
                        v-html="'$ '+format(_.get(objOtros,[keysOtros[1],'valor_total'],0.00))"></td>
                </tr>
                <tr>
                    <td class="p-2">Prima a pagar</td>
                    <td class="text-right" v-html="'$ '+totalPrimaNeta"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'InformacionValoresComponent',
        props: {
            listGeneral: {
                type: Object,
                default: {}
            },
            objModal: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            }
        },
        inject:['apiSend'],
        data() {
            return {
                objImpuestos: {},
                objOtros:{},
                objPrima:{},
                keysOtros:[]
            }
        },
        computed: {
            totalInclusion() {
                var lista = _.clone(_.filter(this.listGeneral.listAccesorios, (v) => {
                    return parseInt(v.genera_solicitud) == 0
                }));
                var total = 0;
                _.forEach(lista, (v) => {
                    total += (v.valorAsegurado);
                });

                return this.format(total);
            },
            totalPrimaBruta() {
                var fechaDesde = moment(this.objModal.fechaDesde);
                var fechaHasta = moment(this.objModal.fechaHasta);
                var diasRestante = fechaHasta.diff(fechaDesde, 'days');
                return this.format(((this.totalInclusion * (parseFloat(_.get(this.objModal, 'tasa_recarga', 0) /
                    100))) / 365) * diasRestante, 2);
            },
            totalPrimaNeta() {
                var listImpuesto = _.clone(this.objImpuestos);
                var listOtros = _.clone(this.objOtros);

                var t = !_.isNaN(this.totalPrimaBruta) ? this.totalPrimaBruta : 0;
                _.forEach(listImpuesto, (v) => {
                    t = parseFloat(t) + parseFloat(_.isNull(v.monto) ? 0 : v.monto);
                });

                _.forEach(listOtros, (v) => {
                    t = parseFloat(t) + parseFloat(_.isNull(v.valor_total) ? 0 : v.valor_total);
                });
                return this.format(t);
            }
        },
        methods: {
            onListarImpuestos(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion: 'LISTAR_X_SEGURO_VEHICULO',
                        id_seguro: _.get(this.objModal, 'idSeguro', null),
                        id_estado: _.get(this.parametros, 'id_estado_default', null),
                        prima_bruta: this.totalPrimaBruta
                    }

                    return this.apiSend('administrador/impuesto/listar', objeto)
                        .then((respuesta) => {
                            if (respuesta.status != 200) throw mensajeEstandar
                                .errorPeticion;
                            if (respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                            if (_.size(respuesta.data.data) == 0) throw respuesta.data.mensaje;
                            var h = [];
                            _.forEach(_.omit(this.parametros, ['accesorios']), (v, k) => {
                                if (_.startsWith(k, 'id_impuesto')) {
                                    h.push({
                                        id_impuesto: v,
                                        impuesto: k
                                    })
                                }
                            });

                            _.map(h, (v) => {
                                var obj = _.merge({}, v, _.find(respuesta.data.data, (val) => {
                                    return parseInt(val.id_impuesto) == parseInt(v.id_impuesto);
                                }));
                                this.$set(this.objImpuestos, v.id_impuesto, obj);
                            });
                            return respuesta;
                        });

                }
            },
            onListarDerechoEmision(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion: 'LISTAR_X_SEGURO_VEHICULO',
                        id_seguro: _.get(this.objModal, 'idSeguro', null),
                        id_estado: _.get(this.parametros, 'id_estado_default', null),
                        prima_bruta: this.totalPrimaBruta
                    }

                    return this.apiSend('administrador/parametro-derecho-emision/listar', objeto)
                        .then((respuesta) => {
                            if (respuesta.status != 200) throw mensajeEstandar
                                .errorPeticion;
                            if (respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                            if (_.size(respuesta.data.data) == 0) throw respuesta.data.mensaje;
                            _.forEach(respuesta.data.data, (v) => {
                                var k = _.get(v, ['tipo_parametro'], null);
                                if (_.isNull(k)) throw mensajeEstandar.errorPeticion;
                                this.$set(this.objOtros, k, v);
                                this.keysOtros.push(k);
                            });

                                this.objPrima = [{
                                    'tipo_prima': 'prima_bruta',
                                    'prima_bruta': this.totalPrimaBruta
                                }, {
                                    'tipo_prima': 'prima_neta',
                                    'prima_neta': this.totalPrimaNeta
                                }];
                            return respuesta;
                        });
                }
            },
            format(num) {
                return Number.parseFloat(_.round(num, 2)).toFixed(2);
            },
        }
    }

</script>